<form [formGroup]="emailsForm">
    <label>
        <span>Escolha os emails que desejam receber o token:</span>
        <mat-select formControlName="ar_emails" class="input mt-3" multiple>
            <div *ngFor="let usuario of usuariosDoCliente">
                <mat-option [value]="usuario.vc_login">{{usuario.vc_login}}</mat-option>
            </div>
        </mat-select>
    </label>
    <div id="buttons" class="d-flex justify-content-end mt-3">
        <button class="btn-sucesso btn btn-lg btn-success" type="submit"
            [ngClass]="{ 'btn-desabilitado': !emailsForm.valid }" [disabled]="!emailsForm.valid"
            (click)="enviarTokenParaOsEmails()">
            Enviar token
        </button>
    </div>
</form>